module.exports = __webpack_public_path__ + "img/care-offer-1.47d179e7.jpg";